/**
 * Injectable timer + clock seam so {@link WsSession} is deterministic under test (a fake scheduler
 * drives every backoff/heartbeat/retry without real sleeps). Default binds to the platform globals.
 */
export type TimerHandle = { readonly __brand: 'timer' };

export interface Timers {
  setTimeout(fn: () => void, ms: number): TimerHandle;
  clearTimeout(handle: TimerHandle | null): void;
  setInterval(fn: () => void, ms: number): TimerHandle;
  clearInterval(handle: TimerHandle | null): void;
  now(): number;
  random(): number;
}

export const systemTimers: Timers = {
  setTimeout: (fn, ms) => setTimeout(fn, ms) as unknown as TimerHandle,
  clearTimeout: (h) => {
    if (h) clearTimeout(h as unknown as ReturnType<typeof setTimeout>);
  },
  setInterval: (fn, ms) => setInterval(fn, ms) as unknown as TimerHandle,
  clearInterval: (h) => {
    if (h) clearInterval(h as unknown as ReturnType<typeof setInterval>);
  },
  now: () => Date.now(),
  random: () => Math.random(),
};
